module.exports = __webpack_public_path__ + "static/media/c4bannerModulE_small.8cb91de6.jpg";